import { render, staticRenderFns } from "./SliderCode.vue?vue&type=template&id=123e3d16&scoped=true"
import script from "./SliderCode.vue?vue&type=script&lang=js"
export * from "./SliderCode.vue?vue&type=script&lang=js"
import style0 from "./SliderCode.vue?vue&type=style&index=0&id=123e3d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123e3d16",
  null
  
)

export default component.exports